<avano-table
  [tableConfiguration]="tableConfig"
  [headerText]="translationKeys.uploadProductDialogComponent.html.dossiersTable.header | translate"
  [tableRef]="uploadProductTable"
>
  <p-table
    #uploadProductTable
    [columns]="cols"
    [value]="dossierData"
    [scrollable]="true"
    scrollHeight="230px"
    [paginator]="true"
    [rows]="10"
    [totalRecords]="totalUploads"
    [resizableColumns]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngFor="let col of columns; let i = index"
          [avanoTableColumnHeader]="col"
          [isLastSortable]="i === columns.length - 1"
          class="scip-avano-table-no-resize-filter"
        ></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="columnKeys.productName" [ngTemplateOutlet]="plainText"></ng-container>
          <ng-container *ngSwitchCase="columnKeys.productNumber" [ngTemplateOutlet]="plainText"></ng-container>
          <ng-container *ngSwitchCase="columnKeys.orgName" [ngTemplateOutlet]="plainText"></ng-container>
          <ng-container *ngSwitchCase="columnKeys.requestedType" [ngTemplateOutlet]="plainText"></ng-container>
          <ng-container *ngSwitchDefault [ngTemplateOutlet]="inputText"></ng-container>

          <ng-template #plainText>
            <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
              {{ rowData | nestedProperty: col.field }}
            </div>
          </ng-template>
          <ng-template #inputText>
            <div
              class="default-input"
              [pTooltip]="translationKeys.uploadProductDialogComponent.html.dossiersTable.column.requiredError | translate"
              [tooltipDisabled]="!col?.required"
            >
              <input
                type="text"
                maxlength="255"
                avanoInputText
                #colInput="ngModel"
                [(ngModel)]="rowData[col.field]"
                (ngModelChange)="col?.required && modelChange.next($event)"
                [attr.title]="rowData[col.field]"
                [required]="col?.required"
              />
              <i class="icon-content-warning p-error" *ngIf="colInput?.invalid && colInput?.dirty"></i>
            </div>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</avano-table>
